'use client';

import * as React from 'react';
import * as SliderPrimitive from '@radix-ui/react-slider';
import { cx } from 'cva';
import Typography from '@ui/Typography';

const UiSlider = React.forwardRef(
  (
    { className, onValuehange, minLabel, maxLabel, showValue = true, ...props },
    ref
  ) => {
    const { value } = props;
    const percentValue = value;
    const showLabel = !!minLabel || !!maxLabel;
    let gradientStyle = '';
    if (percentValue <= 30) {
      gradientStyle = 'from-0% to-[500%]';
    } else if (percentValue <= 60) {
      gradientStyle = 'from-0% to-[190%]';
    } else {
      gradientStyle = 'from-0% to-100%';
    }

    return (
      <SliderPrimitive.Root
        ref={ref}
        className={cx(
          'relative flex w-full touch-none select-none items-center',
          className
        )}
        {...props}>
        <SliderPrimitive.Track className="relative h-2 w-full grow overflow-hidden rounded-full bg-body-background">
          <SliderPrimitive.Range
            className={`absolute h-full shadow-none rounded-full bg-gradient-to-r from-secondary to-primary ${gradientStyle}`}
          />
        </SliderPrimitive.Track>
        <SliderPrimitive.Thumb
          asChild
          className="h-5 w-5 rounded-full cursor-pointer bg-primary focus-visible:outline-none disabled:pointer-events-none disabled:opacity-50">
          <div className="flex justify-center items-start relative">
            <Typography
              variant="body2"
              color="textSecondary"
              className={`absolute -top-5 !font-medium ${
                !showValue && 'hidden'
              }`}>
              {value / 10}%
            </Typography>
          </div>
        </SliderPrimitive.Thumb>
        <div
          className={`w-full absolute top-3 flex justify-between ${
            !showLabel && 'hidden'
          }`}>
          <Typography
            variant="body2"
            color="textDisabled"
            className={!minLabel && 'hidden'}>
            {minLabel}
          </Typography>
          <Typography
            variant="body2"
            color="textDisabled"
            className={!maxLabel && 'hidden'}>
            {maxLabel}
          </Typography>
        </div>
      </SliderPrimitive.Root>
    );
  }
);
UiSlider.displayName = SliderPrimitive.Root.displayName;

function Slider(props) {
  const { onValuehange, onChange, ...rest } = props;

  function handleValueChange(value) {
    if (onValuehange) {
      onValuehange(value);
    }
    if (onChange) {
      onChange(value);
    }
  }

  return <UiSlider onValueChange={handleValueChange} {...rest} />;
}

export default Slider;
